'use client';

import EditorImg from 'lowcode/components/EditorImg';
import { Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { fetchGet, fetchPost } from 'lowcode/utils/service/FetchClient';
import { loginUrl } from 'lowcode/utils/service/baseUrl';
import styles from '../index.module.scss';
import IconClose from './IconClose';
import { tranText } from './tranText';
import FormInput from './FormInput';
import FormSelect from './FormSelect';
import getLocal from '@/app/utils/getLocal';

export default function WinItemForm({ isExchange, activeType, data = {}, winItemCallback }: any) {
    const { locale } = getLocal();
    const textObj = tranText[locale] || tranText['us'];
    const [isClient, setIsClient] = useState(false);
    const [isOpenCheck, setisOpenCheck] = useState(false);

    const initSelectListFn = async () => {
        const res = await fetchGet(`${loginUrl(locale)}/shopify/web/shopifyCountry/selectWithProvince`, locale, null, {
            needToken: true,
        });

        if (res.code === '0') {
            const list1 = res.data || [];
            const data1 = list1[0] || {};
            const listA = (res.data || []).map((item: any) => {
                return {
                    value: item.countryId,
                    label: item.countryName,
                };
            });
            setDataA({
                ...dataA,
                itemVal: (listA[0] || {})?.value || '',
                itemLabel: (listA[0] || {})?.label || '',
            });
            console.log('(listA[0]', (listA[0] || {})?.value || '');
            setSelectListA(listA);
            const provinceList = data1.provinceList || [];
            setSelectListB(
                provinceList.map((item: any) => {
                    return { value: item.provinceId, label: item.provinceName };
                }),
            );
            setDataE2({
                ...dataE2,
                itemVal: (provinceList[0] || {})?.value || '',
                itemLabel: (provinceList[0] || {})?.label || '',
            });
            setIsClient(true);
        }
    };
    useEffect(() => {
        initSelectListFn();
    }, []);
    const closeHandle = () => {
        winItemCallback && winItemCallback('close');
    };
    const [dataA, setDataA] = useState({
        itemKey: 'firstName',
        itemVal: '',
        isRequire: false,
        formType: 'select',
        formWidth: '100',
        placeholder: 'Country/Region',
        emptyTips: 'Country/Region cannot be empty.',
        maxLen: '10',
    });
    const [selectListA, setSelectListA] = useState([]);
    const [selectListB, setSelectListB] = useState([]);
    const [dataB1, setDataB1] = useState({
        itemKey: 'firstName',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '50',
        placeholder: 'First Name',
        emptyTips: 'First name cannot be empty.',
        maxLen: '10',
    });
    const [dataB2, setDataB2] = useState({
        itemKey: 'lastName',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '50',
        placeholder: 'Last Name',
        emptyTips: 'Last name cannot be empty.',
        maxLen: '10',
    });
    const [dataC, setDataC] = useState({
        itemKey: 'address',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '100',
        placeholder: 'My Address',
        emptyTips: 'address cannot be empty.',
        maxLen: '10',
    });
    const [dataD, setDataD] = useState({
        itemKey: 'apt',
        itemVal: '',
        isRequire: false,
        formType: 'input',
        formWidth: '100',
        placeholder: 'Apt, Suite, Building(optional)',
        emptyTips: '',
        maxLen: '10',
    });
    const [dataE1, setDataE1] = useState({
        itemKey: 'city',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '50',
        placeholder: 'city',
        emptyTips: 'city cannot be empty.',
        maxLen: '10',
    });
    const [dataE2, setDataE2] = useState({
        itemKey: 'firstName',
        itemVal: '',
        isRequire: false,
        formType: 'select',
        formWidth: '50',
        placeholder: 'State',
        emptyTips: 'State cannot be empty.',
        maxLen: '10',
    });
    const [dataF1, setDataF1] = useState({
        itemKey: 'zip',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '100',
        placeholder: 'zip',
        emptyTips: 'zip cannot be empty.',
        maxLen: '10',
    });
    const [dataF2, setDataF2] = useState({
        itemKey: 'phone',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '100',
        placeholder: 'phone',
        emptyTips: 'phone cannot be empty.',
        maxLen: '10',
    });
    const [dataF3, setDataF3] = useState({
        itemKey: 'email',
        itemVal: '',
        isRequire: true,
        formType: 'input',
        formWidth: '100',
        placeholder: 'email',
        emptyTips: 'email cannot be empty.',
        maxLen: '10',
    });

    //
    const itemFormCallback = (data: any, val: string, name: string) => {
        if (name === 'dataA') {
            setDataA({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataB1') {
            setDataB1({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataB2') {
            setDataB2({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataC') {
            setDataC({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataD') {
            setDataD({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataE1') {
            setDataE1({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataE2') {
            setDataE2({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataF1') {
            setDataF1({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataF2') {
            setDataF2({
                ...data,
                itemVal: val,
            });
        } else if (name === 'dataF3') {
            setDataF3({
                ...data,
                itemVal: val,
            });
        }
    };

    const submitHandle = async () => {
        setisOpenCheck(true);
        const flag = true;

        const params = {
            ruleId: data.ruleId,
            ruleVersion: data.version,
            ruleSiteVersion: data?.ruleWebsite?.version,

            address: {
                countryCode: dataA.itemVal,
                countryName: dataA.itemVal,

                firstName: dataB1.itemVal,
                lastName: dataB2.itemVal,

                address1: dataC.itemVal,
                address2: dataD.itemVal,
                city: dataE1.itemVal,
                company: dataE2.itemVal,

                zip: dataF1.itemVal,
                phone: dataF2.itemVal,
                email: dataF3.itemVal,

                customerId: '',

                province: '',
                provinceCode: '',
            },
        };
        const res = await fetchPost(`${loginUrl(locale)}/integral/web/rewardRedeemCoupon/redeem`, locale, params, {
            needToken: true,
        });
        if (res.code === '0') {
            closeHandle();
        }
    };

    if (isClient) {
        return ReactDOM.createPortal(
            <div className={`glo-editor-modal glo-editor-modal-show ${styles['eco-win']} ${styles['eco-win-form']}`}>
                <div className={`glo-editor-modal-content scrollbar-editor-white eco-redeem-rewards-winitem ${styles.content}`}>
                    <div className="glo-editor-modal-header">
                        <IconClose onClick={closeHandle} />
                    </div>
                    <div className={`glo-editor-modal-body eco-redeem-rewards-winitem-${activeType}`}>
                        <div className="eco-redeem-rewards-card">
                            <div className="eco-redeem-rewards-card-img">
                                <EditorImg pc={data.rulePic} />
                            </div>
                            <div className="eco-redeem-rewards-card-desc">
                                <div className="eco-redeem-rewards-card-desc1">{data?.goodTitle || textObj.card_discount_code}</div>
                                <div className="eco-redeem-rewards-card-desc2">
                                    {data?.points}&nbsp;
                                    {textObj.card_credits}
                                </div>
                            </div>
                        </div>
                        <div className="eco-redeem-rewards-winitem-note">
                            <div className="eco-redeem-rewards-winitem-title">{textObj.card_rules}</div>
                            <div
                                className="eco-redeem-rewards-winitem-desc"
                                dangerouslySetInnerHTML={{
                                    __html: data.ruleDescription,
                                }}
                            ></div>
                        </div>
                        {isExchange && (
                            <>
                                <div className="eco-redeem-form">
                                    <Fragment key={selectListA.length}>
                                        <div
                                            className={`form-common-item${
                                                isOpenCheck && dataA.isRequire && !dataA.itemVal ? ' form-common-show-error' : ''
                                            } form-common-item-${dataA.formWidth}`}
                                        >
                                            <FormSelect data={dataA} callback={itemFormCallback} name="dataA" list={selectListA} />
                                        </div>
                                    </Fragment>
                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataB1.isRequire && !dataB1.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataB1.formWidth}`}
                                    >
                                        <FormInput data={dataB1} callback={itemFormCallback} name="dataB1" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataB2.isRequire && !dataB2.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataB2.formWidth}`}
                                    >
                                        <FormInput data={dataB2} callback={itemFormCallback} name="dataB2" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataC.isRequire && !dataC.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataC.formWidth}`}
                                    >
                                        <FormInput data={dataC} callback={itemFormCallback} name="dataC" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataD.isRequire && !dataD.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataD.formWidth}`}
                                    >
                                        <FormInput data={dataD} callback={itemFormCallback} name="dataD" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataE1.isRequire && !dataE1.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataE1.formWidth}`}
                                    >
                                        <FormInput data={dataE1} callback={itemFormCallback} name="dataE1" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataE2.isRequire && !dataE2.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataE2.formWidth}`}
                                    >
                                        <Fragment key={selectListB.length}>
                                            <FormSelect data={dataE2} callback={itemFormCallback} name="dataE2" list={selectListB} />
                                        </Fragment>
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataF1.isRequire && !dataF1.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataF1.formWidth}`}
                                    >
                                        <FormInput data={dataF1} callback={itemFormCallback} name="dataF1" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataF2.isRequire && !dataF2.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataF2.formWidth}`}
                                    >
                                        <FormInput data={dataF2} callback={itemFormCallback} name="dataF2" />
                                    </div>

                                    <div
                                        className={`form-common-item${
                                            isOpenCheck && dataF3.isRequire && !dataF3.itemVal ? ' form-common-show-error' : ''
                                        } form-common-item-${dataF3.formWidth}`}
                                    >
                                        <FormInput data={dataF3} callback={itemFormCallback} name="dataF3" />
                                    </div>
                                </div>
                                <div className="eco-redeem-rewards-winitem-tips">{textObj.win_item_desc}</div>
                                <div className="eco-redeem-rewards-winitem-confirm" onClick={submitHandle}>
                                    {textObj.win_item_btn}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>,
            document.body,
        );
    }
    return null;
}
